import { isArray } from 'util';
import { ArticleCamFile } from '../article-cam-file';

export class ArticleCamFileBuilder {
  static fromJson(json) {
    return (json)
      ? new ArticleCamFile(
        json.hash,
        json.mimeType,
        json.fileName,
        json.filePath,
        json.isPDF,
        json.isImage
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(ArticleCamFileBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/article-cam-file.builder.ts